import KeycloakService from "../../services/KeycloakService";

const API_URL = window.env.REACT_APP_API;
const buildUrl = (url) => (url.startsWith("/", 0) ? `${API_URL + url}` : `${API_URL}/${url}`);

function parseSSEEvent(chunk) {
	const lines = chunk.split("\n");
	let data = "";
	let event = "message";

	for (const line of lines) {
		if (line.startsWith("data:")) {
			data += `${line.slice(5).trimStart()}\n`;
		} else if (line.startsWith("event:")) {
			event = line.slice(6).trim();
		}
	}

	data = data.trim();

	let parsedData = null;
	try {
		parsedData = data ? JSON.parse(data) : null;
	} catch {
		parsedData = data;
	}

	return { event, data: parsedData };
}

/**
 * @param {Function} onMessage - Callback function triggered when a new message is received from the stream.
 * @param {Function} onError - Callback function triggered when an error occurs.
 * @param {Function} onOpen - Callback function triggered when the connection is successfully established.
 */
export default function connectSSE(url, { body = null, method = "GET", onError, onMessage, onOpen } = {}) {
	const controller = new AbortController();
	const { signal } = controller;
	fetch(buildUrl(url), {
		method,
		headers: {
			Accept: "text/event-stream",
			Authorization: KeycloakService.getToken(),
		},
		body,
		signal,
	})
		.then((res) => {
			if (!res.ok || !res.body) {
				throw new Error(`SSE connection failed: ${res.status}`);
			}
			if (typeof onOpen === "function") {
				onOpen(res);
			}
			const reader = res.body.getReader();
			const decoder = new TextDecoder("utf-8");
			let buffer = "";
			function read() {
				reader
					.read()
					.then(({ done, value }) => {
						if (done) {
							return;
						}
						buffer += decoder.decode(value, { stream: true });
						const parts = buffer.split("\n\n");
						buffer = parts.pop() || "";

						parts.forEach((part) => {
							if (!part) {
								return;
							}
							const parsed = parseSSEEvent(part);
							if (parsed.event === "ping" || parsed.data === "ping") {
								return;
							}
							if (typeof onMessage === "function") {
								onMessage(parsed);
							}
						});
						read();
					})
					.catch((err) => {
						if (typeof onError === "function" && !signal?.aborted) {
							onError(err);
						}
					});
			}

			read();
		})
		.catch((err) => onError && onError(err));
	return () => controller.abort();
}
